<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:waybillNo="{ row }">
        <div>
          <el-link
            type="primary"
            @click="openDetailPageDialog(row.waybillCode)"
          >
            {{ row.waybillNo }}
          </el-link>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="撤销运单"
              v-allow="'actCancelWaybill'"
              placement="top"
            >
              <i class="el-icon-refresh-left tool-btn" @click="cancel(row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="派单"
              v-allow="'actSendWaybill'"
              placement="top"
              v-if="row.wayBillStatus === '0'"
            >
              <i class="el-icon-truck tool-btn" @click="isSend(row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="派单变更"
              placement="top"
              v-if="row.wayBillStatus === '2'"
            >
              <i class="el-icon-edit-outline tool-btn" @click="isSend(row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="运单打印"
              v-allow="'actPrint'"
              placement="top"
              v-if="row.wayBillStatusName !== '已取消'"
            >
              <i
                class="el-icon-printer tool-btn"
                @click="print(row.waybillCode)"
              ></i>
            </el-tooltip>
          </b-button-group>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <set-send
      :listWaybill="selectList"
      :visible="sendVisible"
      @close="() => (sendVisible = false)"
      @reload="() => $emit('reload')"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import SetSend from '../../../dispatch/components/waybill/setSend'
export default {
  components: {
    SetSend,
  },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },

  data() {
    return {
      selectList: [],
      sendVisible: false,
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
    }
  },
  methods: {
    cancel(row) {
      this.selectList = []
      this.selectList.push(row.waybillCode)
      this.$confirm('确认要对当前的运输单，进行撤回操作吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.commitCancel()
      })
    },
    print(code) {
      this.selectList = []
      this.selectList.push(code)
      this.$api.printPDF('/order/waybill/print', {
        listWaybillCode: this.selectList,
      })
    },
    async batchCancel() {
      const selectCode = await this.getSelectData('code')
      if (!selectCode) {
        return
      }
      this.$confirm('确认要对选中的运输单，进行撤回操作吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.commitCancel()
      })
    },
    batchPrint() {},
    isSend(row) {
      this.selectList = []
      this.selectList.push(row)
      this.sendVisible = true
      // this.$confirm('确认要对当前的运输单，进行派单操作吗？', '确认信息', {
      //   type: 'warning',
      // }).then(() => {
      //   this.commitSend()
      // })
    },
    async batchIsSend() {
      // 批量派车
      const selectCode = await this.getSelectData('row')
      if (!selectCode) {
        return
      }

      for (let i = 0; i < this.selectList.length - 1; i++) {
        let j = this.selectList[i].carrierCode
        let k = this.selectList[i + 1].carrierCode
        if (j !== k) {
          this.$message({
            showClose: true,
            message: '请选择相同的承运商！',
            type: 'warning',
          })
          return
        }
      }

      this.sendVisible = true
      // this.$confirm('确认要对选中的运输单，进行派单操作吗？', '确认信息', {
      //   type: 'warning',
      // }).then(() => {
      //   this.commitSend()
      // })
    },
    // commitSend() {
    //   this.$api
    //     .bizWaybillAssignApi({
    //       listWaybillCode: this.selectList,
    //     })
    //     .then((res) => {
    //       this.$message({
    //         showClose: true,
    //         message: res.msg,
    //         type: 'success',
    //       })
    //       this.$emit('reload')
    //     })
    // },
    commitCancel() {
      this.$api
        .bizWaybillCancelApi({
          listWaybillCode: this.selectList,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
    },
    getSelectData(selectType) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的运输单')
        return false
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.waybillCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量选择的运输单数量，不能超过20张')
        return false
      }
      return true
    },
    openDetailPageDialog(no) {
      this.$router.push({
        name: 'carriage-waybill-detail-page',
        params: { no },
      })
    },
  },
}
</script>
